/**
 * Import required libraries
 */
import React, { useState, useRef } from "react";
import { connect } from "react-redux";
import { chat as chatApi } from "api";

/**
 * Import Components and Styles
 */
import ChatBoxDiv from "./render";

/**
 * ChatBox Component
 */
function ChatBox(props) {
  let { lang, labelPath, uid, user, name = "", messages = [] } = props;
  //console.log("porpos :",props)
  //console.log("uid of chatBox :",uid)
  labelPath += ".chatbox";

  const [input, setInput] = useState("");
  const [openedEmoji, openEmoji] = useState(false);

  /**
   * Update state on text input change
   * @param  {Object} event Change event
   * @return {null}
   */
  function onChange(event) {
    event.preventDefault();
    setInput(event.target.value);
  }

  /**
   * Add message to chatArray and emit change_key
   * @param  {Object} event     Submit event
   * @param  {Array} chatArray  Array of messages
   * @return {null}
   */
  function sendMessage(event) {
    event.preventDefault();
    if (input !== "") {
      console.log("sendMessage", {
        chat: uid,
        message: input
      });
      chatApi.post({
        chat: uid,
        message: input
      })
        .then(() => setInput(""))
        .catch(console.error)
    } else {
      //message vide, bloquage du bouton d'envoie à implémenter
    }
  }

  const scrollRef = useRef(null);

  return (
    <ChatBoxDiv uid={uid}
      lang={lang}
      labelPath={labelPath}
      title={name}
      messages={messages}
      input={input}
      onChange={onChange}
      user={user}
      sendMessage={sendMessage}
      scrollRef={scrollRef}
      emojiProps={{
        opened: openedEmoji,
        open: e => openEmoji(!openedEmoji),
        close: e => openEmoji(false),
        popupProps: {
          addEmoji: k => setInput(prev => `${prev} ${k}`)
        }
      }}
    />
  );
}

/**
 * Export component
 */
// map redux state to props
export default connect((state, { uid }) => {
  const chats = state.list.chat || {};
  const chat = chats[uid] || {};
  return {
    ...chat,
    lang: state.locale.lang,
    user: state.user
  };
})(ChatBox);
